import React from 'react'
import { Link, Redirect } from 'react-static'
import {connect} from 'react-redux'
import SignInForm from '../components/SignInForm'
import {signinWithEmailAndPassword} from '../actions/account'
import Spinner from '../components/Spinner'
import ActivateAccount from '../components/ActivateAccount'

const Authenticated = ({authUser}) => {
  if(authUser.emailVerified) {
    // return <Redirect to='/orders'/>
    return (
      <Redirect to='/orders'/>
    )
  }

  return (
    <ActivateAccount email={authUser.email}>
      <br/>
      Andere Email verwenden{' '}
      <Link to='/signup'>Registrieren</Link>
    </ActivateAccount>
  )
}

const SignIn = ({authUser,isFetching}) =>
  <div>
    <div className="text-center m-b-20">
      <Link to="/" className="logo-lg">
        <img src="logo_light_32.png" alt="logo"/>{' '}
        <span>ColorRibbon</span>
      </Link>
    </div>

    {isFetching
      ?
      <Spinner/>
      :
      (authUser
        ?
        <Authenticated authUser={authUser}/>
        :
        <SignInForm authUser={authUser} signin={signinWithEmailAndPassword}/>
      )
    }
  </div>

export default connect(
  state => ({
    authUser: state.account.authUser,
    isFetching: state.account.isFetching
  })
)(SignIn)



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/SignIn.js